import React from 'react';

class Bem {
  block: string;
  _elem?: string;
  _mods?: (string | boolean)[];

  constructor(block: string) {
    this.block = block;
  }

  static _mod(name: string, mod: string): string {
    return `${name}--${mod}`;
  }

  cls(mixCls?: string): string {
    const { block, _elem, _mods } = this;
    let css = block;

    if (_elem) {
      css = `${block}__${_elem}`;
    }

    if (_mods) {
      const mods = _mods
        .filter(Boolean)
        .map((mod) => Bem._mod(css, mod.toString()))
        .join(' ');

      css = [css, mods].join(' ');
    }

    if (mixCls) {
      if (Array.isArray(mixCls)) {
        const localMixCls = mixCls.filter(Boolean).join(' ');

        css = [localMixCls, css].join(' ');
      } else {
        css = [mixCls, css].join(' ');
      }
    }

    this._reset();

    return css;
  }

  _reset(): void {
    this._mods = undefined;
    this._elem = undefined;
  }

  mods(...mods: (string | boolean)[]): Bem {
    this._mods = mods;
    return this;
  }

  elem(elem: string): Bem {
    this._elem = elem;
    return this;
  }
}

const bemBlocks = {} as any;
const useBem = (block: string): Bem => bemBlocks[block] ?? (bemBlocks[block] = new Bem(block));

const withBem = (block: string) => (Component: React.ComponentType): React.ComponentType => {
  const WithBem = (props: any) => <Component {...props} bem={useBem(block)} />;

  return WithBem;
};

export { Bem, useBem, withBem };
